export const SystemName = {
	ContainerTransportType: {
		Standard: "Standard",
		Side: "Side"
	},
	DocumentType: {
		DGDocument: "DG Document",
		Document: "Document",
		ExternalDGDocument: "External DG Document",
		MPIDocument: "MPI Document",
		NZDGDocument: "NZ DG Document"
	},
	DocumentTypeGroup: {
		BLLBooking: "BLLBooking",
		BLLDGBooking: "BLLDGBooking"
	},
	FlagType: {
		LocationUserCreated: "Location.UserCreated"
	},
	GeoCoordinateInformationType: {
		BoothsNotification: "BoothsNotification",
		GeneralEvent: "GeneralEvent",
		SignificantEvent: "SignificantEvent"
	},
	GoodsLoad: {
		Full: "Full",
		Empty: "Empty"
	},
	IntegrationSource: {
		ICOS: "ICOS",
		Ignition: "IGNITION"
	},
	LocationType: {
		Address: "Address",
		Terminal: "Terminal",
		Area: "BLLArea",
		Port: "BLLPort",
		Park: "BLLPark",
		Client: "Client",
		ClientPortPark: "ClientPortPark",
		StorageYard: "StorageYard"
	},
	Lookup: {
		BLLLocation: "BLLPortalLocation"
	},
	CTLocationType: {
		Address: "Address",
		Area: "Area",
		Client: "Client",
		ClientPortPark: "ClientPortPark",
		Country: "Country",
		Pack: "Pack",
		Park: "Park",
		Port: "Port",
		Rail: "Rail",
		Terminal: "Terminal",
		Unpack: "Unpack",
		Warehouse: "Warehouse"
	},
	MovementType: {
		Import: "Import",
		Export: "Export",
		Move: "Move"
	},
	NotificationType: {
		ConsignmentNotification: "ConsignmentNotification"
	},
	NotificationTransportType: {
		Email: "Email",
		Messaging: "Messaging",
		MessageMedia: "MessageMedia"
	},
	Setting: {
		PlumsailClaimFormBaseURL: "PlumsailClaimFormBaseURL"
	},
	SettingType: {
		PortalUISetting: "PortalUISetting"
	},
	UserSetting: {
		DashboardMapView: "TrackPageMapView",
		DashboardBlockFilters: "DashboardBlockFilters"
	},
	JobType: {
		ExportFCLTransportOrder: "ExportFCLTransportOrder",
		ImportFCLTransportOrder: "ImportFCLTransportOrder"
	},
	ContainerTransport: {
		PortalContainerTransportContainerArrivingToday: "BLLPortalContainerTransportContainerArrivingToday",
		PortalContainerTransportContainerAtLocation: "BLLPortalContainerTransportContainerAtLocation",
		PortalContainerTransportContainerCompleted: "BLLPortalContainerTransportContainerCompleted",
		PortalContainerTransportContainerDashboard: "BLLPortalContainerTransportContainerDashboard",
		PortalContainerTransportContainerDashboardGrid: "BLLPortalContainerTransportContainerDashboardGrid",
		PortalContainerTransportContainerInStorageYard: "BLLPortalContainerTransportContainerInStorageYard",
		PortalContainerTransportOrderArrivingInDays: "BLLPortalContainerTransportOrderArrivingInDays",
		PortalContainerTransportOrderDashboard: "BLLPortalContainerTransportOrderDashboard",
		PortalContainerTransportOrderDashboardGrid: "BLLPortalContainerTransportOrderDashboardGrid",
		PortalContainerTransportOrderInTransit: "BLLPortalContainerTransportOrderInTransit",
		PortalContainerTransportOrderWatchlist: "BLLPortalContainerTransportOrderWatchlist",
		// Update when bll general freight stored procedures are implemented
		PortalGeneralFreightDashboard: "PortalGeneralFreightDashboard",
		PortalGeneralFreightNotYetDeparted: "PortalGeneralFreightNotYetDeparted",
		PortalGeneralFreightInTransit: "PortalGeneralFreightInTransit",
		PortalGeneralFreightArrivingDelivered: "PortalGeneralFreightArrivingDelivered",
		PortalGeneralFreightWatchlist: "PortalGeneralFreightWatchlist",
		//Update when bll move stored procedures are implemented
		PortalMoveTransportContainerDashboard: "PortalMoveTransportContainerDashboard",
		PortalMoveTransportContainerDashboardGrid: "PortalMoveTransportContainerDashboardGrid",
		PortalMoveTransportContainerNotYetDeparted: "PortalMoveTransportContainerNotYetDeparted",
		PortalMoveTransportContainerNotYetDepartedGrid: "PortalMoveTransportContainerNotYetDepartedGrid",
		PortalMoveTransportContainerInTransit: "PortalMoveTransportContainerInTransit",
		PortalMoveTransportContainerInTransitGrid: "PortalMoveTransportContainerInTransitGrid",
		PortalMoveTransportContainerDeliveredToday: "PortalMoveTransportContainerDeliveredToday",
		PortalMoveTransportContainerDeliveredTodayGrid: "PortalMoveTransportContainerDeliveredTodayGrid",
		PortalMoveTransportContainerWatchlist: "PortalMoveTransportContainerWatchlist",
		PortalMoveTransportContainerWatchlistGrid: "PortalMoveTransportContainerWatchlistGrid",
		PortalMoveTransportOrderDashboard: "PortalMoveTransportOrderDashboard",
		PortalMoveTransportOrderDashboardGrid: "PortalMoveTransportOrderDashboardGrid",
		PortalMoveTransportOrderInTransit: "PortalMoveTransportOrderInTransit",
		PortalMoveTransportOrderInTransitGrid: "PortalMoveTransportOrderInTransitGrid",
		PortalMoveTransportOrderArrivingInDays: "PortalMoveTransportOrderArrivingInDays",
		PortalMoveTransportOrderArrivingInDaysGrid: "PortalMoveTransportOrderArrivingInDaysGrid",
		PortalMoveTransportOrderWatchlist: "PortalMoveTransportOrderWatchlist",
		PortalMoveTransportOrderWatchlistGrid: "PortalMoveTransportOrderWatchlistGrid"
	},
	ReportFormat: {
		ContainerConsignmentNote: "RPT_BLLCTContainerConsignmentNote"
	}
};
